<template>
	<div>
		<section-invalid v-if="showInvalid"/>
		<section-expired v-else-if="showExpired"/>
		<div v-else>
			<banner-top
				:configuration="configuration"
				@get-banner-value="getBannerValue"
			/>
			<section-header
				:banner-visible="bannerVisible"
				:disabled-register-app="disabledRegisterApp"
				:disabled-payment="disabledPayment"
			/>
			<banner
				:banner-visible="bannerVisible"
				:disabled-register-app="disabledRegisterApp"
				:disabled-payment="disabledPayment"
			/>
			<section-generate-app 
				:disabled-register-app="disabledRegisterApp"
				:token="token"
				:departaments="departaments"
			/>
			<section-benefits />
			<section-question />
		</div>
		<new-footer gray />
	</div>
</template>
<script>
import bannerTop from '@/components/generate-app/banner-top';
import banner from '@/components/generate-app/banner';
import sectionGenerateApp from '@/components/generate-app/section-generate-app';
import newFooter from '@/components/home/new-footer';
import sectionBenefits from '@/components/generate-app/section-benefits';
import sectionQuestion from '@/components/generate-app/section-question';
import sectionHeader from '@/components/generate-app/section-header';
import sectionInvalid from '@/components/generate-app/section-invalid';
import sectionExpired from '@/components/generate-app/section-expired';

function created() {
	this.loadData();
	this.loadDepartaments();
}

async function loadData() {
	const coupon = process.env.COUPON;
	const params = {
		hour: process.env.PROMOTION_EXPIRATION,
	};
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	try {
		const response = await this.$http.get(`store-status/${coupon}`,
			{ params, headers });
		this.configuration = response.data;
		const endDateTime = new Date(response.endDate).getTime();
		const startDateTime = new Date(response.startDate).getTime();
		this.timeEnd = endDateTime - startDateTime < 0;
		if (this.configuration.appConfig) {
			this.goTo('page-success-inscription',
				{
					params: {
						fullName: `${this.configuration.appConfig.name} ${this.configuration.appConfig.surName}`,
					},
				},
			);
		}
	} catch (error) {
		if (error.data.statusCode === 401) {
			if (error.data.message === 'Bad token') {
				this.showInvalid = true;
			} else if (error.data.message === 'Expired') {
				this.showExpired = true;
			}
		}
	}
}

function disabledRegisterApp() {
	return !this.configuration.flagAssigned || this.configuration.flagAppConfig || this.timeEnd;
}

function disabledPayment() {
	return !this.configuration.flagAssigned || this.configuration.flagPayment || this.timeEnd;
}

function getBannerValue(value) {
	this.bannerVisible = value;
}

async function loadDepartaments() {
	const url = this.isPeru ? `province/public?countryCode=${process.env.COUNTRY}` : 'province/public';
	try {
		const { data: response } = await this.$http.get(url);
		this.departaments = response;
	} catch (error) {
		this.showGenericError();
	}
}

function data() {
	return {
		bannerVisible: true,
		configuration: {
			color: {
				fifth: '#000000',
				fourth: '#ffffff',
				id: 1,
				primary: '#02979b',
				secondary: '#b1dc03',
				tertiary: '#085f65',
			},
		},
		timeEnd: false,
		departaments: [],
		showInvalid: false,
		showExpired: false,
	};
}

export default {
	name: 'page-generate-app',
	created,
	computed: {
		disabledRegisterApp,
		disabledPayment,
	},
	data,
	components: {
		bannerTop,
		newFooter,
		sectionGenerateApp,
		banner,
		sectionBenefits,
		sectionQuestion,
		sectionHeader,
		sectionInvalid,
		sectionExpired,
	},
	methods: {
		getBannerValue,
		loadData,
		loadDepartaments,
	},
	props: {
		token: String,
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/page-generate-app.vue